import { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useLocation, useNavigate } from 'react-router-dom';
import { CallWithAuth } from '../../../actions/apiAction';
import { GET_SUBSCRIPTION_DETAILS, CONFIRM_CHECKOUT_SESSION } from '../../../utils/apiUrl';
const PaymentSuccess = () => {
    const navigator = useNavigate();
    const { search } = useLocation();
    const query = new URLSearchParams(search);
    const creatorId = query.get("id");
    const planId = query.get("plan_id");
    const sessionId = query.get("session_id");
    const [countdown, setCountdown] = useState(7);
    const [subscriptionData, setSubscriptionData] = useState(null);

    useEffect(() => {
        const interval = setInterval(() => {
            setCountdown((prev) => {
                if (prev <= 1) {
                    clearInterval(interval);
                    navigator('/user/chat?id=' + creatorId, { replace: true });
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);

        return () => clearInterval(interval);
    }, [navigator]);

    const getSubscriptionDetails = async () => {
        const response = await CallWithAuth("GET", GET_SUBSCRIPTION_DETAILS(planId));
        if (response?.data) {
            setSubscriptionData(response?.data)
        };
    };
    const gotoNext = () => {
        if (creatorId) {
            navigator('/user/chat?id=' + creatorId, { replace: true })
        } else {
            navigator('/user/creator-list', { replace: true })
        }

    }
    useEffect(() => {
        const confirmCheckout = async () => {
            if (!sessionId) return;
            await CallWithAuth("POST", CONFIRM_CHECKOUT_SESSION, { session_id: sessionId });
        };
        confirmCheckout();
        if (planId) getSubscriptionDetails();
    }, [planId, sessionId])
    return (
        <>
            <Helmet>
                <title>Payment Success</title>
            </Helmet>
            <div className="min-h-screen gradient-bg-1 flex flex-col items-center justify-center p-6 relative overflow-hidden">
                <div className="absolute inset-0 pointer-events-none">
                    <div
                        className="absolute w-2 h-2 bg-primary rounded-full animate-float-slow"
                        style={{
                            left: '5%',
                            top: '10%'
                        }}
                    />
                    <div
                        className="absolute w-2 h-2 bg-primary rounded-full animate-float-fast"
                        style={{
                            left: '10%',
                            top: '25%'
                        }}
                    />
                    <div
                        className="absolute w-2 h-2 bg-primary rounded-full animate-float-slow"
                        style={{
                            left: '13%',
                            top: '90%'
                        }}
                    />
                    <div
                        className="absolute w-2 h-2 bg-primary rounded-full animate-float-fast"
                        style={{
                            left: '15%',
                            top: '70%'
                        }}
                    />
                    <div
                        className="absolute w-2 h-2 bg-primary rounded-full animate-float-slow"
                        style={{
                            left: '17%',
                            top: '30%'
                        }}
                    />
                    <div
                        className="absolute w-2 h-2 bg-primary rounded-full animate-float-fast"
                        style={{
                            left: '20%',
                            top: '40%'
                        }}
                    />
                    <div
                        className="absolute w-2 h-2 bg-primary rounded-full animate-float-medium"
                        style={{
                            left: '12%',
                            top: '50%'
                        }}
                    />
                    <div
                        className="absolute w-2 h-2 bg-primary rounded-full animate-float-slow"
                        style={{
                            left: '75%',
                            top: '10%'
                        }}
                    />
                    <div
                        className="absolute w-2 h-2 bg-primary rounded-full animate-float-medium"
                        style={{
                            left: '70%',
                            top: '20%'
                        }}
                    />
                    <div
                        className="absolute w-2 h-2 bg-primary rounded-full animate-float-slow"
                        style={{
                            left: '75%',
                            top: '40%'
                        }}
                    />
                    <div
                        className="absolute w-2 h-2 bg-primary rounded-full animate-float-medium"
                        style={{
                            left: '80%',
                            top: '50%'
                        }}
                    />
                    <div
                        className="absolute w-2 h-2 bg-primary rounded-full animate-float-slow"
                        style={{
                            left: '30%',
                            top: '60%'
                        }}
                    />
                    <div
                        className="absolute w-2 h-2 bg-primary rounded-full animate-float-fast"
                        style={{
                            left: '85%',
                            top: '70%'
                        }}
                    />
                    <div
                        className="absolute w-2 h-2 bg-primary rounded-full animate-float-medium"
                        style={{
                            left: '90%',
                            top: '80%'
                        }}
                    />
                    <div
                        className="absolute w-2 h-2 bg-primary rounded-full animate-float-slow"
                        style={{
                            left: '38%',
                            top: '80%'
                        }}
                    />
                    <div
                        className="absolute w-2 h-2 bg-primary rounded-full animate-float-medium"
                        style={{
                            left: '40%',
                            top: '95%'
                        }}
                    />
                    <div
                        className="absolute w-2 h-2 bg-primary rounded-full animate-float-slow"
                        style={{
                            left: '96%',
                            top: '10%'
                        }}
                    />
                    <div
                        className="absolute w-2 h-2 bg-primary rounded-full animate-float-medium"
                        style={{
                            left: '88%',
                            top: '50%'
                        }}
                    />
                    <div
                        className="absolute w-2 h-2 bg-primary rounded-full animate-float-fast"
                        style={{
                            left: '83%',
                            top: '70%'
                        }}
                    />
                    <div
                        className="absolute w-2 h-2 bg-primary rounded-full animate-float-slow"
                        style={{
                            left: '90%',
                            top: '40%'
                        }}
                    />
                </div>
                <div className="relative z-10 text-center w-full max-w-[277px]" style={{ transform: "none" }}>
                    <div
                        className="w-32 h-32 bg-success rounded-full flex items-center justify-center mx-auto mb-8 shadow-2xl"
                        style={{ transform: "none" }}
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width={24}
                            height={24}
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="#fff"
                            strokeWidth={3}
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="lucide lucide-check w-16 h-16 text-white"
                        >
                            <path d="M20 6 9 17l-5-5" />
                        </svg>
                    </div>
                    <div style={{ opacity: 1, transform: "none" }}>
                        <div className="flex items-center justify-center gap-2 mb-4">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="lucide lucide-sparkles w-6 h-6 text-accent"
                            >
                                <path d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z" />
                                <path d="M20 3v4" />
                                <path d="M22 5h-4" />
                                <path d="M4 17v2" />
                                <path d="M5 18H3" />
                            </svg>
                            <h1 className="text-3xl font-bold text-white">You're in!</h1>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="lucide lucide-sparkles w-6 h-6 text-accent"
                            >
                                <path d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z" />
                                <path d="M20 3v4" />
                                <path d="M22 5h-4" />
                                <path d="M4 17v2" />
                                <path d="M5 18H3" />
                            </svg>
                        </div>
                        <p className="text-xl text-white mb-2 font-medium">
                            You're all set…
                        </p>
                        <p className="text-white mb-8 max-w-sm">
                            {subscriptionData?.plan_type === 'add-on'
                                ? 'Extra minutes have been added to this billing period.'
                                : (subscriptionData?.description || "Your subscription has been successfully processed.")}
                        </p>
                        {
                            subscriptionData && <div className=" bg-[#0f0e1499] rounded-2xl p-4 mb-6 text-left shadow-lg border  !border-[#ffffff1a]">
                                <h3 className="font-semibold text-white mb-3 text-sm">
                                    Order Confirmation
                                </h3>
                                <div className="space-y-2 text-sm">
                                    <div className="flex justify-between">
                                        <span className="text-white">Plan</span>
                                        <span className="font-medium text-white">{subscriptionData?.name}</span>
                                    </div>
                                    <div className="flex justify-between items-center">
                                        <span className="text-white">Amount</span>
                                        <div className="text-right">
                                            {subscriptionData?.slashed_price !== null ? <span className="text-xs text-white line-through mr-2">
                                                ${subscriptionData?.slashed_price}/{subscriptionData?.interval}
                                            </span> : null}
                                            <span className="font-medium text-white">
                                                ${subscriptionData?.price}
                                                {subscriptionData?.interval === 'one_time'
                                                    ? ' one-time'
                                                    : `/${subscriptionData?.interval == 'monthly' ? 'month' : 'year'}`}
                                            </span>
                                        </div>
                                    </div>
                                    {subscriptionData?.discount_percentage !== null ? <div className="flex justify-between">
                                        <span className="text-muted-white">Discount</span>
                                        <span className="font-medium text-success">{subscriptionData?.discount_percentage}% OFF</span>
                                    </div> : null}
                                    {/* <div className="flex justify-between items-center">
                                    <span className="text-muted-foreground flex items-center gap-1">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width={24}
                                            height={24}
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth={2}
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            className="lucide lucide-calendar w-3 h-3"
                                        >
                                            <path d="M8 2v4" />
                                            <path d="M16 2v4" />
                                            <rect width={18} height={18} x={3} y={4} rx={2} />
                                            <path d="M3 10h18" />
                                        </svg>
                                        Next billing{" "}
                                    </span>
                                    <span className="font-medium text-foreground">Jan 2, 2026</span>
                                </div> */}
                                </div>
                            </div>}
                        <button className="whitespace-nowrap  disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0  bg-primary   text-primary-foreground hover:opacity-90 rounded-full px-8 py-6 text-lg font-semibold shadow-lg transition-all duration-300 hover:shadow-xl hover:scale-105 w-full mb-4 flex items-center justify-center gap-2"
                            onClick={() => gotoNext()}
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="#fff"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="lucide lucide-smartphone w-4 h-4"
                            >
                                <rect width={14} height={20} x={5} y={2} rx={2} ry={2} />
                                <path d="M12 18h.01" />
                            </svg>
                            Continue{" "}
                        </button>
                        <p className="text-xs text-white mb-2">
                            Redirecting in {countdown} second{countdown !== 1 ? 's' : ''}...
                        </p>
                        <button className="text-sm text-primary hover:text-primary/80 underline transition-colors"
                            onClick={() => gotoNext()}
                        >
                            Skip to Chat
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
}

export default PaymentSuccess;
